/* Every internal URL the marketing pages link to.

   signIn and signUp arrived as guesses (/login, /register) and are corrected
   here against `bin/rails routes`. Sign-in is /session/new because a session is
   a singular resource — a visitor has at most one in this browser — and signup
   is /sign-up rather than /register because the word is what the CTA says. */
export const routes = {
  home: '/',
  pricing: '/pricing',
  methodology: '/methodology',
  faq: '/faq',
  blog: '/blog',
  grader: '/grader',
  signIn: '/session/new',
  signOut: '/session',
  signUp: '/sign-up',
  dashboard: '/dashboard',
  terms: '/terms',
  privacy: '/privacy',
  refund: '/refund',
  contact: '/contact',
  // Signed in only: a visitor who is not is sent to sign in, then lands here.
  account: '/account/edit',
};
